<span *ngIf="isNumber(rowData[renderValue])"><a href="javascript:void(0);" (click)="mobileSearch(rowData[renderValue])">{{ rowData[renderValue] }}</a></span>
<span *ngIf="!isNumber(rowData[renderValue])">{{ rowData[renderValue] }}</span>